import { render } from "./BackerCenterPaymentsView.vue?vue&type=template&id=38c332ee"
import script from "./BackerCenterPaymentsView.vue?vue&type=script&lang=js"
export * from "./BackerCenterPaymentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__